import { render, staticRenderFns } from "./EmployeeMovementForm.vue?vue&type=template&id=4c152034&"
import script from "./EmployeeMovementForm.vue?vue&type=script&lang=js&"
export * from "./EmployeeMovementForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports